export type LLCDesignator = 'LLC' | 'L.L.C.' | 'Limited Liability Company'

export type CorpDesignator = 'Inc.' | 'Corp' | 'Corporation' | 'Incorporated' | 'Ltd.' | 'Limited'

export const llcDesignators: LLCDesignator[] = ['LLC', 'L.L.C.', 'Limited Liability Company']

export const corpDesignators: CorpDesignator[] = ['Inc.', 'Corp', 'Corporation', 'Incorporated', 'Ltd.', 'Limited']
